var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.19036 7.80074C2.52592 7.13653 1.19703 5.80812 0.532585 5.14391C0.266807 4.87823 0.266807 4.47971 0.532585 4.21402C0.798363 3.94834 1.19703 3.94834 1.46281 4.21402C1.99436 4.74539 3.58903 6.33948 3.58903 6.33948C3.58903 6.33948 7.04414 2.02214 8.43948 0.295203C8.63881 0.0295204 9.03748 -0.103321 9.3697 0.0959409C9.70192 0.295203 9.76837 0.760148 9.50259 1.09225C8.04081 2.88561 4.98436 6.67158 4.18703 7.6679C4.00141 7.89985 3.85481 8 3.65548 8C3.45614 8 3.32325 7.93358 3.19036 7.80074Z",
    fill: "#F44F01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.bc441bfe8894e3cd03aef5f641800863.svg";
export { ForwardRef as ReactComponent };